import React, { useContext } from "react";
import { generateClassString } from "../../../lib/helper/generateClassString";
import AccordionContext from "../AccordionContext";
import AccordionItemContext from "../AccordionItem/AccordionItemContext";

import * as styles from './component.module.less'

export default function AccordionButton({
    className,
    children,
    ...additionalProps
}) {
    const { activeItem, setActiveItem } = useContext(AccordionContext);
    const { eventKey } = useContext(AccordionItemContext);

    return (
        // TODO: Replace <button> with Button component
        <button
            {...additionalProps}
            className={generateClassString(className, styles.accordionButton)}
            onClick={() => {
                setActiveItem(activeItem === eventKey ? null : eventKey);
            }}
        >
            {children}
        </button>
    );
}
